var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSlider4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 548,
    height: 436,
    fill: "none",
    viewBox: "0 0 548 436",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M446.063 308.588s-9.987 13.241-19.976 31.409c-9.005 16.383-15.854 38.459-17.366 56.89-4.242-.2-8.901-.389-13.937-.567-29.831-1.059-72.897-1.722-120.783-1.722-54.44 0-102.649.858-132.264 2.178-1.02.045-2.018.091-2.993.137C101.77 351.086 27.317 271.245 95.834 238.4c0 0 5.02-1.528 12.545-4.812 23.818-10.396 72.763-38.369 67.319-91.111 0 0-1.855-9.841-1.855-23.536 0-32.021 10.137-85.1 77.816-82.678 40.985 1.47 78.73 22.325 101.551 55.708 22.383 32.742 58.173 73.026 87.319 50.028 6.728-5.311 15.624-7.279 23.929-4.944 20.98 5.893 44.813 36.399-18.395 171.533Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B4DFF",
    d: "M114.116 220.273a1.43 1.43 0 0 1-1.842-.511 57.612 57.612 0 0 1-2.442-4.22 1.429 1.429 0 1 1 2.533-1.325 54.483 54.483 0 0 0 2.32 4.008 1.43 1.43 0 0 1-.569 2.048Zm-5.479-11.183a1.43 1.43 0 0 1-1.985-.794 57.336 57.336 0 0 1-1.453-4.65 1.429 1.429 0 1 1 2.762-.736c.395 1.482.86 2.968 1.381 4.419a1.429 1.429 0 0 1-.705 1.761Zm-2.881-12.111a1.43 1.43 0 0 1-2.058-1.107 57.188 57.188 0 0 1-.379-4.859 1.43 1.43 0 0 1 2.857-.1c.054 1.537.175 3.089.36 4.615a1.428 1.428 0 0 1-.78 1.451Zm-.1-12.453a1.43 1.43 0 0 1-2.059-1.429c.169-1.611.41-3.233.716-4.823a1.43 1.43 0 0 1 2.808.541 54.263 54.263 0 0 0-.681 4.581 1.429 1.429 0 0 1-.784 1.13Zm2.679-12.163a1.43 1.43 0 0 1-1.991-1.74 57.994 57.994 0 0 1 1.765-4.542 1.43 1.43 0 0 1 2.619 1.147 55.098 55.098 0 0 0-1.679 4.317 1.421 1.421 0 0 1-.714.818Zm5.303-11.267a1.43 1.43 0 0 1-1.858-2.027 57.821 57.821 0 0 1 2.728-4.039 1.43 1.43 0 1 1 2.299 1.699 54.51 54.51 0 0 0-2.591 3.838 1.423 1.423 0 0 1-.578.529Zm45.344-26.44a1.403 1.403 0 0 1-.586.149 53.69 53.69 0 0 0-4.615.369 1.43 1.43 0 0 1-.35-2.838 57.004 57.004 0 0 1 4.861-.388 1.429 1.429 0 0 1 .69 2.708ZM121.3 151.291a1.428 1.428 0 0 1-1.659-2.28 56.506 56.506 0 0 1 3.558-3.329 1.43 1.43 0 0 1 1.862 2.17 53.942 53.942 0 0 0-3.379 3.16 1.42 1.42 0 0 1-.382.279Zm25.369-14.78a1.423 1.423 0 0 1-.269.102 55.039 55.039 0 0 0-4.419 1.391 1.43 1.43 0 0 1-.972-2.689 57.962 57.962 0 0 1 4.649-1.463 1.429 1.429 0 0 1 1.011 2.659Zm-15.708 6.932a1.428 1.428 0 0 1-1.407-2.483 56.742 56.742 0 0 1 4.213-2.449l.027-.014a1.429 1.429 0 0 1 1.303 2.544 54.347 54.347 0 0 0-4.002 2.327 1.621 1.621 0 0 1-.134.075Zm38.044-8.244a1.418 1.418 0 0 1-.843.135 55.6 55.6 0 0 0-2.211-.276 1.43 1.43 0 0 1 .297-2.843c.776.081 1.558.178 2.325.29a1.43 1.43 0 0 1 .432 2.694Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M206.253 157.822a1.43 1.43 0 0 1-1.799-.446c-.429-.599-.878-1.2-1.335-1.784a1.43 1.43 0 0 1 2.253-1.76c.481.615.954 1.247 1.406 1.878a1.43 1.43 0 0 1-.525 2.112Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M185.943 240.074c-.588.294-1.184.579-1.787.855a1.429 1.429 0 0 1-1.19-2.6 55.042 55.042 0 0 0 4.063-2.065 1.43 1.43 0 0 1 1.401 2.492c-.81.456-1.647.899-2.487 1.318Zm-8.847 3.52a1.438 1.438 0 0 1-.226.09c-1.527.462-3.09.864-4.646 1.195a1.43 1.43 0 1 1-.595-2.795 54.604 54.604 0 0 0 4.413-1.136 1.43 1.43 0 0 1 1.054 2.646Zm17.62-8.969a1.43 1.43 0 0 1-1.501-2.419 53.58 53.58 0 0 0 3.508-2.904 1.43 1.43 0 0 1 1.915 2.124 56.947 56.947 0 0 1-3.695 3.058 1.423 1.423 0 0 1-.227.141Zm-29.672 11.204a1.427 1.427 0 0 1-.535.146 56.822 56.822 0 0 1-4.795.144 1.429 1.429 0 1 1 .036-2.858 54.468 54.468 0 0 0 4.553-.137 1.43 1.43 0 0 1 .741 2.705Zm38.548-19.642a1.43 1.43 0 0 1-1.732-2.2 54.243 54.243 0 0 0 2.784-3.604 1.43 1.43 0 0 1 2.333 1.651 57.247 57.247 0 0 1-2.93 3.795c-.13.154-.285.274-.455.358Zm6.811-10.181a1.43 1.43 0 0 1-1.908-1.938 55.033 55.033 0 0 0 1.932-4.126 1.43 1.43 0 1 1 2.637 1.103 58.045 58.045 0 0 1-2.033 4.342 1.422 1.422 0 0 1-.628.619Zm4.428-11.424a1.43 1.43 0 0 1-2.019-1.647c.39-1.464.722-2.961.987-4.448a1.43 1.43 0 0 1 2.815.502 57.94 57.94 0 0 1-1.039 4.681c-.11.413-.39.735-.744.912Zm1.832-12.117a1.429 1.429 0 0 1-2.065-1.336c.06-1.513.056-3.046-.012-4.556a1.429 1.429 0 1 1 2.855-.129c.072 1.591.076 3.205.013 4.798a1.43 1.43 0 0 1-.791 1.223Zm-.873-12.228a1.428 1.428 0 0 1-2.045-1.019 54.287 54.287 0 0 0-1.015-4.44 1.43 1.43 0 0 1 2.757-.754 57.01 57.01 0 0 1 1.069 4.674 1.431 1.431 0 0 1-.766 1.539Zm-3.536-11.73a1.428 1.428 0 0 1-1.955-.719 55.159 55.159 0 0 0-1.956-4.116 1.429 1.429 0 0 1 .599-1.931c.7-.386 1.562-.1 1.93.598a57.673 57.673 0 0 1 2.057 4.331 1.428 1.428 0 0 1-.675 1.837Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "M152.762 245.349c-.254.127-.548.18-.85.135a57.22 57.22 0 0 1-2.31-.398 1.429 1.429 0 0 1 .542-2.807c.729.141 1.468.268 2.194.378a1.428 1.428 0 0 1 .424 2.692Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "M147.083 229.654a.67.67 0 0 0 .761-.151l5.574-5.919a35.44 35.44 0 0 0 11.471.355l5.198 6.246a.667.667 0 0 0 .75.197l9.121-3.454a.67.67 0 0 0 .431-.645l-.244-8.122a35.425 35.425 0 0 0 8.357-7.865l8.097.741a.668.668 0 0 0 .67-.391l4.007-8.892a.67.67 0 0 0-.151-.761l-5.92-5.575c.73-3.726.87-7.596.356-11.47l6.246-5.198a.667.667 0 0 0 .197-.75l-3.454-9.121a.667.667 0 0 0-.645-.431l-8.123.243a35.415 35.415 0 0 0-7.864-8.356l.741-8.098a.67.67 0 0 0-.391-.67l-8.892-4.006a.666.666 0 0 0-.761.151l-5.575 5.919a35.433 35.433 0 0 0-11.47-.355l-5.198-6.246a.668.668 0 0 0-.75-.198l-9.121 3.455a.667.667 0 0 0-.431.645l.243 8.122a35.419 35.419 0 0 0-8.356 7.865l-8.098-.741a.669.669 0 0 0-.67.391l-4.006 8.892a.668.668 0 0 0 .151.761l5.919 5.574a35.407 35.407 0 0 0-.355 11.47l-6.246 5.199a.666.666 0 0 0-.197.75l3.454 9.121a.67.67 0 0 0 .645.431l8.122-.244a35.423 35.423 0 0 0 7.865 8.357l-.741 8.097a.668.668 0 0 0 .391.67l8.892 4.007Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M164.603 197.383c-4.276 2.134-9.598.868-12.413-3.164-3.094-4.434-2.005-10.557 2.428-13.651a9.738 9.738 0 0 1 7.328-1.613 9.74 9.74 0 0 1 6.322 4.041c3.094 4.434 2.005 10.557-2.428 13.651-.4.279-.814.524-1.237.736Zm-7.717-15.509a7.582 7.582 0 0 0-.959.569c-3.399 2.372-4.234 7.068-1.862 10.466 2.372 3.399 7.067 4.236 10.466 1.862 3.399-2.371 4.234-7.067 1.862-10.465a7.462 7.462 0 0 0-4.847-3.099 7.458 7.458 0 0 0-4.66.667Z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M171.107 209.962a24.475 24.475 0 0 1-6.749 2.216l-.051.009-.147.024c-.096.016-.191.031-.287.045a.572.572 0 1 1-.17-1.13 23.093 23.093 0 0 0 4.729-1.24c7.61-2.881 12.8-9.396 14.348-16.826a22.824 22.824 0 0 0-1.007-12.782 23.384 23.384 0 0 0-.947-2.165c-2.354-4.713-6.225-8.443-11.093-10.636a22.81 22.81 0 0 0-17.567-.539c-11.845 4.488-17.825 17.767-13.341 29.607.277.73.589 1.443.936 2.137a22.886 22.886 0 0 0 6.284 7.737.571.571 0 1 1-.709.897 24.048 24.048 0 0 1-7.58-10.366c-4.708-12.431 1.578-26.375 14.005-31.082 6.022-2.281 12.571-2.079 18.441.566 5.111 2.302 9.175 6.218 11.646 11.166.367.736.699 1.494.995 2.273 2.28 6.022 2.08 12.571-.566 18.442-2.303 5.112-6.22 9.176-11.17 11.647Z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1B4DFF",
    d: "M162.986 129.42a.957.957 0 0 1-1.233-.342 38.486 38.486 0 0 1-1.634-2.823.956.956 0 0 1 .404-1.291l.017-.009a.956.956 0 0 1 1.274.413 36.71 36.71 0 0 0 1.552 2.682.956.956 0 0 1-.38 1.37Zm-3.667-7.483a.957.957 0 0 1-1.328-.531 38.712 38.712 0 0 1-.972-3.111.956.956 0 1 1 1.848-.493c.265.992.575 1.986.924 2.957a.955.955 0 0 1-.472 1.178Zm-1.927-8.103a.956.956 0 0 1-1.377-.741 38.015 38.015 0 0 1-.254-3.252.957.957 0 1 1 1.912-.066c.036 1.028.117 2.067.241 3.087a.957.957 0 0 1-.522.972Zm-.067-8.333a.957.957 0 0 1-1.378-.956c.114-1.078.275-2.164.479-3.227a.958.958 0 0 1 1.879.362 35.935 35.935 0 0 0-.455 3.065.958.958 0 0 1-.525.756Zm1.792-8.139a.956.956 0 0 1-1.332-1.164 38.587 38.587 0 0 1 1.182-3.039.958.958 0 0 1 1.752.768 36.986 36.986 0 0 0-1.124 2.888.948.948 0 0 1-.478.547Zm3.549-7.539a.957.957 0 0 1-1.243-1.356 38.302 38.302 0 0 1 1.825-2.702.956.956 0 1 1 1.538 1.137 36.897 36.897 0 0 0-1.734 2.567.95.95 0 0 1-.386.354Zm30.34-17.69a.952.952 0 0 1-.391.099c-1.027.037-2.067.12-3.089.246a.957.957 0 0 1-.234-1.898 38.024 38.024 0 0 1 3.253-.26.956.956 0 0 1 .461 1.812Zm-25.213 11.13a.957.957 0 0 1-1.11-1.526 38.227 38.227 0 0 1 2.38-2.227.957.957 0 1 1 1.246 1.452c-.78.669-1.541 1.38-2.261 2.114a.953.953 0 0 1-.255.187Zm16.974-9.89a.938.938 0 0 1-.18.069 36.67 36.67 0 0 0-2.956.93.957.957 0 0 1-.651-1.8 38.662 38.662 0 0 1 3.111-.978.957.957 0 0 1 .676 1.779Zm-10.51 4.639a.955.955 0 0 1-.942-1.662 38.247 38.247 0 0 1 2.82-1.639l.018-.01a.956.956 0 0 1 .871 1.703 36.435 36.435 0 0 0-2.677 1.557.809.809 0 0 1-.09.05Zm25.456-5.517a.952.952 0 0 1-.564.09 37.087 37.087 0 0 0-1.479-.184.956.956 0 1 1 .198-1.902c.52.054 1.043.119 1.556.194a.957.957 0 0 1 .289 1.802Z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M224.636 87.633a.956.956 0 0 1-1.203-.3c-.288-.4-.588-.802-.893-1.192a.955.955 0 1 1 1.507-1.178c.322.412.638.835.941 1.256a.957.957 0 0 1-.352 1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M211.048 142.669c-.394.197-.793.388-1.196.572a.957.957 0 0 1-.797-1.739 37.038 37.038 0 0 0 2.719-1.382.957.957 0 0 1 .938 1.667c-.543.305-1.103.602-1.664.882Zm-5.92 2.356a1.068 1.068 0 0 1-.152.06 38.07 38.07 0 0 1-3.108.799.955.955 0 1 1-.399-1.87 36.98 36.98 0 0 0 2.954-.76.956.956 0 0 1 .705 1.771Zm11.79-6.002a.957.957 0 0 1-1.005-1.618 36.21 36.21 0 0 0 2.348-1.943.958.958 0 0 1 1.281 1.421 38.527 38.527 0 0 1-2.472 2.046c-.049.036-.1.068-.152.094Zm-19.854 7.497a.976.976 0 0 1-.358.098 38.182 38.182 0 0 1-3.209.096.956.956 0 1 1 .024-1.913 36.025 36.025 0 0 0 3.047-.091.955.955 0 0 1 .496 1.81Zm25.793-13.143a.956.956 0 0 1-1.159-1.472 36.381 36.381 0 0 0 1.862-2.411.956.956 0 1 1 1.562 1.104 37.853 37.853 0 0 1-1.961 2.539.953.953 0 0 1-.304.24Zm4.557-6.812a.955.955 0 0 1-1.276-1.297c.467-.899.902-1.828 1.292-2.761a.957.957 0 0 1 1.765.738c-.411.982-.869 1.96-1.36 2.905a.964.964 0 0 1-.421.415Zm2.963-7.644a.957.957 0 0 1-1.351-1.102c.261-.98.483-1.981.661-2.977a.956.956 0 1 1 1.883.336 38.755 38.755 0 0 1-.695 3.133.958.958 0 0 1-.498.61Zm1.226-8.108a.955.955 0 0 1-1.382-.894c.04-1.013.037-2.038-.008-3.048a.957.957 0 0 1 1.911-.087c.048 1.065.05 2.145.008 3.211a.955.955 0 0 1-.529.818Zm-.585-8.182a.956.956 0 0 1-1.368-.682 36.173 36.173 0 0 0-.679-2.97.958.958 0 0 1 1.845-.505c.282 1.029.522 2.081.715 3.127a.958.958 0 0 1-.513 1.03Zm-2.366-7.849a.957.957 0 0 1-1.308-.481 36.698 36.698 0 0 0-1.308-2.754.956.956 0 0 1 .4-1.292.946.946 0 0 1 1.292.4 37.97 37.97 0 0 1 1.376 2.898.956.956 0 0 1-.452 1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "M188.845 146.199a.955.955 0 0 1-.569.09 38.439 38.439 0 0 1-1.546-.266.956.956 0 1 1 .363-1.878c.488.094.982.179 1.468.252a.957.957 0 0 1 .284 1.802Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEBFFF",
    d: "M185.044 135.697a.447.447 0 0 0 .509-.101l3.73-3.961c2.494.488 5.083.582 7.675.238l3.479 4.179c.122.147.323.2.501.132l6.104-2.311a.447.447 0 0 0 .288-.432l-.163-5.434a23.705 23.705 0 0 0 5.592-5.263l5.418.496c.19.017.37-.088.448-.261l2.681-5.95a.449.449 0 0 0-.101-.51l-3.961-3.73c.488-2.493.582-5.082.238-7.675l4.179-3.478a.445.445 0 0 0 .132-.502l-2.311-6.103a.448.448 0 0 0-.432-.288l-5.435.163a23.695 23.695 0 0 0-5.262-5.592l.496-5.418a.448.448 0 0 0-.262-.448l-5.95-2.681a.447.447 0 0 0-.509.1l-3.73 3.962a23.697 23.697 0 0 0-7.675-.238l-3.478-4.18a.447.447 0 0 0-.502-.132l-6.103 2.312a.447.447 0 0 0-.288.431l.163 5.435a23.7 23.7 0 0 0-5.592 5.263l-5.418-.496a.446.446 0 0 0-.448.261l-2.681 5.95a.446.446 0 0 0 .101.51l3.961 3.729a23.675 23.675 0 0 0-.238 7.675l-4.18 3.479a.449.449 0 0 0-.132.502l2.312 6.103a.446.446 0 0 0 .431.288l5.435-.163a23.705 23.705 0 0 0 5.263 5.592l-.496 5.418c-.018.19.087.37.261.448l5.95 2.681Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M196.767 114.104c-2.861 1.428-6.422.581-8.305-2.117a6.566 6.566 0 0 1 1.625-9.134 6.515 6.515 0 0 1 4.903-1.08 6.518 6.518 0 0 1 4.23 2.705 6.567 6.567 0 0 1-2.453 9.626Zm-5.163-10.378a5.036 5.036 0 0 0-1.888 7.385 5.035 5.035 0 0 0 7.003 1.246 5.035 5.035 0 0 0 1.246-7.003 4.994 4.994 0 0 0-3.243-2.074 4.993 4.993 0 0 0-3.118.446Z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M201.119 122.521a16.37 16.37 0 0 1-4.516 1.483l-.034.006-.099.016c-.063.011-.128.02-.191.03a.385.385 0 0 1-.436-.321.383.383 0 0 1 .321-.435 15.52 15.52 0 0 0 3.165-.83c5.092-1.928 8.565-6.287 9.601-11.259.576-2.765.399-5.72-.674-8.552-.188-.497-.4-.98-.634-1.449a15.246 15.246 0 0 0-7.423-7.117 15.263 15.263 0 0 0-11.754-.36c-7.926 3.002-11.927 11.888-8.926 19.81a15.304 15.304 0 0 0 4.83 6.607.382.382 0 1 1-.474.6 16.09 16.09 0 0 1-5.072-6.936c-3.15-8.318 1.056-17.648 9.371-20.797a16.025 16.025 0 0 1 12.34.378 16.003 16.003 0 0 1 7.792 7.472c.246.492.468 1 .665 1.521a16.019 16.019 0 0 1-.378 12.339 16.009 16.009 0 0 1-7.474 7.794Z",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE0FF",
    stroke: "#141C24",
    strokeMiterlimit: 10,
    d: "M389.377 179.212c0-58.344-47.298-105.642-105.642-105.642-58.345 0-105.642 47.298-105.642 105.642 0 34.493 16.531 65.124 42.103 84.404 8.679 6.544 13.85 16.728 13.85 27.598v17.703h99.377v-17.703c0-10.87 5.171-21.054 13.851-27.598 25.571-19.28 42.103-49.911 42.103-84.404Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3062D4",
    d: "M229.507 293.273v71.464c0 2.221.218 4.39.639 6.488 3.013 15.077 16.324 26.437 32.287 26.437h42.604a32.8 32.8 0 0 0 22.302-8.704 32.883 32.883 0 0 0 9.985-17.733c.42-2.098.639-4.267.639-6.488v-71.464H229.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3062D4",
    d: "M337.669 302.844H229.803l-3.129-12.723h114.124l-3.129 12.723Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCE0FF",
    d: "M337.964 302.763H229.507v8.27h108.457v-8.27Zm0 20.064H229.507v8.27h108.457v-8.27Zm0 20.065H229.507v8.27h108.457v-8.27Zm-108.457 20.064v1.78c0 2.222.219 4.391.64 6.49h107.177c.42-2.099.64-4.268.64-6.49v-1.78H229.507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#141C24",
    d: "m226.614 290.188 2.892 11.454v63.094c0 2.222.22 4.391.64 6.49 3.013 15.075 16.324 26.436 32.286 26.436h42.605c8.603 0 16.436-3.3 22.301-8.703-15.367 4.404-30.162 3.274-41.833.672a47.796 47.796 0 0 1-36.983-40.193c-2.609-19.022-1.035-44.329.676-59.25h-22.584Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M283.735 209.927c46.42 0 84.05-27.806 84.05-62.106s-37.63-62.105-84.05-62.105c-46.421 0-84.051 27.805-84.051 62.105s37.63 62.106 84.051 62.106Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M283.735 166.107c30.044 0 54.399-17.997 54.399-40.196 0-22.199-24.355-40.195-54.399-40.195s-54.399 17.996-54.399 40.195 24.355 40.196 54.399 40.196Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    d: "M343.529 149.961a64.676 64.676 0 0 0-13.904-20.625A64.662 64.662 0 0 0 309 115.433c-8.009-3.388-16.51-5.105-25.265-5.105-8.756 0-17.256 1.717-25.265 5.105a64.666 64.666 0 0 0-20.626 13.903 64.69 64.69 0 0 0-13.903 20.625c-3.387 8.01-5.105 16.51-5.105 25.266 0 8.755 1.718 17.256 5.105 25.265a64.678 64.678 0 0 0 13.903 20.625 64.65 64.65 0 0 0 20.626 13.903c8.009 3.388 16.509 5.105 25.265 5.105 8.755 0 17.256-1.717 25.265-5.105a64.646 64.646 0 0 0 20.625-13.903 64.665 64.665 0 0 0 13.904-20.625c3.387-8.009 5.105-16.51 5.105-25.265 0-8.756-1.718-17.256-5.105-25.266Zm-9.296 25.266c0 27.844-22.653 50.498-50.498 50.498s-50.498-22.654-50.498-50.498c0-27.845 22.653-50.498 50.498-50.498s50.498 22.653 50.498 50.498Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052CC",
    d: "M289.572 155.106c-4.424 0-7.876 1.812-10.355 5.436-2.479 3.624-3.718 8.621-3.718 14.991 0 13.241 5.036 19.861 15.108 19.861 3.043 0 5.993-.424 8.848-1.271a88.355 88.355 0 0 0 8.613-3.059v15.719c-5.742 2.542-12.237 3.813-19.485 3.813-10.386 0-18.348-3.012-23.885-9.037-5.539-6.024-8.307-14.731-8.307-26.121 0-7.122 1.341-13.382 4.024-18.779 2.682-5.396 6.542-9.546 11.578-12.448 5.036-2.902 10.958-4.354 17.767-4.354 7.436 0 14.543 1.616 21.32 4.848l-5.695 14.637a64.122 64.122 0 0 0-7.625-3.012c-2.541-.816-5.27-1.224-8.188-1.224Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M182.424 398.3s-.836 4.738-1.247 9.427c-.16 1.833 1.253 3.424 3.091 3.501 6.245.26 19.603.765 24.397.552a1.051 1.051 0 0 0 .925-1.44 2.353 2.353 0 0 0-1.204-1.268l-22.065-10.142-3.897-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m181.739 395.517.673 5.666s3.865 1.8 6.504-.227l-1.6-6.314-5.577.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M182.244 288.985c-.29 1.48-1.559 73.844 6.176 106.273a1.1 1.1 0 0 1-.645 1.28c-1.187.485-3.513 1.187-6.3 1.281a1.897 1.897 0 0 1-1.881-1.361c-2.211-7.524-12.806-45.221-14.188-81.233-1.544-40.239 0-1.37 0-1.37l.906-24.873 15.932.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M157.042 400.772s-1.332 2.391-2.622 8.746a1.971 1.971 0 0 0 1.735 2.361c2.062.203 5.236.464 7.779.446 1.172-.008 2.087-1.029 1.946-2.192-.282-2.32-1.159-6.126-3.87-9.092l-4.968-.269Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m155.872 393.483 1.571 8.57s1.553 1.155 4.626.317l-.75-9.22-5.447.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F3CD9",
    d: "M151.628 291.206c-6.327 38.18 1.372 94.365 3.969 105.361a1.716 1.716 0 0 0 1.384 1.303c1.159.192 3.067.348 4.948-.198a1.57 1.57 0 0 0 1.13-1.447c.349-8.891-.278-63.47 5.616-85.04a4.903 4.903 0 0 1 1.89-2.703l11.442-8.134.877-13.147-31.256 4.005Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4174FF",
    d: "M191.94 218.862c-18.959-.313-39.878 4.978-39.878 4.978-5.651 32.975-.988 71.009-.988 71.009 14.677 3.849 31.234-2.353 31.234-2.353 2.44-13.783 13.822-52.572 13.822-52.572 9.263-1.15 16.452-4.348 22.736-7.881-4.793-5.556-6.611-12.101-7.592-16.28-6.704 2.083-13.487 3.195-19.334 3.099Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M241.393 180.821c-1.862-2.25-4.179 0-4.179 0-2.79 11.785-10.912 30.271-25.942 34.942.982 4.179 2.8 10.724 7.593 16.28 24.942-14.024 22.528-51.222 22.528-51.222Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M241.086 181.43c.325.562-1.674 1.972-3.52-.214-.308-1.175-2.156-6.094-1.662-7.217 2.631-5.981 8.516-14.052 8.516-14.052 1.507.946.754 2.37.754 2.37l-2.728 4.484c1.039 1.177 2.196 2.108 2.98 3.636.594 1.158.689 2.514.316 3.77-.374 1.26-.9 2.908-1.45 4.228-1.041 2.498-3.206 2.995-3.206 2.995Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "m241.426 169.544-2.626 3.459-.409 2.954 3.592 2.559s-.232-5.63.229-6.962c.46-1.332-.039-1.816-.786-2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "m159.333 242.198-7.272-18.358s-17.708 12.032-20.621 27.288c3.346.246 9.435 1.117 15.395 4.126 1.309-7.204 12.498-13.056 12.498-13.056Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M174.809 259.472s-19.882 11.236-26.591 1.642c-1.393-1.993-1.726-3.973-1.383-5.86-5.959-3.009-12.048-3.88-15.394-4.126-.878 4.599-.414 9.49 2.288 14.434 11.752 21.496 43.711-1.188 43.711-1.188l-2.631-4.902Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m172.804 272.347 10.272-35.873a2.171 2.171 0 0 1 1.84-1.559c2.42-.277 7.619-.848 13.53-1.347 7.175-.607 15.397-1.11 20.969-.856 1.569.071 2.548 1.727 1.849 3.133-3.954 7.95-15.272 30.339-21.389 38.614a2.159 2.159 0 0 1-1.759.871l-23.246-.216a2.17 2.17 0 0 1-2.066-2.767Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M175.041 264.532s-1.512-6.216-.902-8.421c.61-2.205 1.791-5.04 5.729-4.41 3.938.63 8.583 2.289 8.583 2.289s-.235 2.872-3.228 1.945l1.856 1.436s-.265 2.3-2.793 1.071l1.726 1.905s-1.086 1.889-2.946.677c-1.859-1.211-2.751 4.256-8.025 3.508Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "m172.736 203.47-6.032 17.446c-.1.289.019.609.286.756 1.645.91 7.569 3.538 14.709-.989a2.96 2.96 0 0 0 1.363-2.114l1.953-15.099h-12.279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M185.862 187.315s6.624 12.47 5.775 17.507c-.849 5.037-9.059 4.675-16.228.584l-5.01-13.464 15.463-4.627Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#272E35",
    d: "M175.726 198.794a.513.513 0 0 0 .224-.752c-.53-.811-1.525-2.465-1.843-3.913 0 0-1.19-.763 3.031-1.773 4.222-1.011 10.518-2.579 11.841-6.173 1.29-3.503-2.1-12.314-7.508-5.294a.514.514 0 0 1-.814.006c-.887-1.154-3.218-3.549-6.454-2.097-3.028 1.359-3.369 3.578-3.328 4.696a.51.51 0 0 1-.605.523c-1.531-.292-5.205-.542-6.921 3.227-1.412 3.105-.494 4.862.342 5.721a.513.513 0 0 1-.219.851c-1.007.308-2.306 1.161-2.176 3.519.18 3.259 3.824 2.972 4.862 2.824a.513.513 0 0 1 .456.161c.889.984 4.898 5.164 9.236 5.668a.518.518 0 0 0 .543-.685l-1.877-5.457a.517.517 0 0 1 .279-.64l.931-.412Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M176.481 199.568s-4.717-3.235-5.061-.51c-.345 2.725 4.247 3.947 6.521 2.931l-1.46-2.421Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M411.337 171.996c11.956 0 21.648-9.692 21.648-21.648s-9.692-21.648-21.648-21.648c-11.955 0-21.648 9.692-21.648 21.648s9.693 21.648 21.648 21.648Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M411.338 171.276c11.559 0 20.928-9.37 20.928-20.928 0-11.558-9.369-20.928-20.928-20.928-11.558 0-20.928 9.37-20.928 20.928 0 11.558 9.37 20.928 20.928 20.928Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M393.839 142.897a.7.7 0 0 1-.655-.995c3.214-6.896 9.931-11.326 17.53-11.563 1.212-.037 2.43.034 3.619.212a.7.7 0 0 1-.208 1.384 18.913 18.913 0 0 0-3.368-.197c-7.067.221-13.314 4.341-16.305 10.754a.7.7 0 0 1-.613.405Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M424.33 163.316c6.917-6.917 6.917-18.132 0-25.05-6.918-6.917-18.133-6.917-25.05 0-6.917 6.918-6.918 18.133 0 25.05 6.917 6.918 18.132 6.918 25.05 0Z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "m410.481 164.006-.06-1.926c-2.01-.018-4.011-.43-5.441-1.004a1.114 1.114 0 0 1-.657-1.297l.434-1.809a1.123 1.123 0 0 1 1.501-.783c1.418.543 3.16.953 5.023.895 1.934-.06 3.356-.761 3.314-2.105-.038-1.212-1.175-1.899-3.885-2.536-3.868-.929-6.674-2.515-6.779-5.892-.095-3.048 2.061-5.445 5.91-6.188l-.06-1.927a1.121 1.121 0 0 1 1.087-1.157l1.132-.035a1.122 1.122 0 0 1 1.157 1.087l.054 1.729c1.86.017 3.223.292 4.308.636.556.176.875.759.74 1.326l-.399 1.674a1.12 1.12 0 0 1-1.453.802c-1-.343-2.41-.689-4.226-.632-2.294.071-2.92 1.042-2.894 1.895.033 1.049 1.432 1.727 4.444 2.552 4.301 1.145 6.126 2.86 6.226 6.04.091 2.917-1.991 5.607-6.167 6.393l.068 2.156a1.123 1.123 0 0 1-1.088 1.157l-1.132.036a1.123 1.123 0 0 1-1.157-1.087Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M414.913 234.008c13.776 0 24.944-11.168 24.944-24.945 0-13.777-11.168-24.945-24.944-24.945-13.777 0-24.945 11.168-24.945 24.945 0 13.777 11.168 24.945 24.945 24.945Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M414.913 233.178c13.319 0 24.115-10.797 24.115-24.115 0-13.319-10.796-24.115-24.115-24.115-13.318 0-24.115 10.796-24.115 24.115 0 13.318 10.797 24.115 24.115 24.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M395.411 198.735a.45.45 0 0 1-.376-.668c4.184-7.549 12.136-12.032 20.754-11.698 1.376.053 2.748.23 4.08.526a.45.45 0 1 1-.196.879 22.045 22.045 0 0 0-3.918-.506c-8.277-.32-15.914 3.985-19.933 11.235a.449.449 0 0 1-.411.232Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M429.846 224.042c7.971-7.971 7.971-20.894 0-28.865s-20.894-7.971-28.865 0-7.971 20.894 0 28.865 20.894 7.971 28.865 0Z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "m412.83 224.693.085-2.219c-2.309-.182-4.576-.816-6.174-1.59a1.284 1.284 0 0 1-.65-1.544l.643-2.045a1.295 1.295 0 0 1 1.789-.779c1.586.738 3.556 1.35 5.702 1.433 2.228.086 3.918-.605 3.978-2.154.054-1.397-1.197-2.277-4.262-3.227-4.371-1.379-7.469-3.428-7.318-7.318.135-3.512 2.807-6.093 7.29-6.639l.086-2.219a1.295 1.295 0 0 1 1.343-1.243l1.304.051c.714.027 1.27.629 1.243 1.343l-.077 1.992c2.137.168 3.681.595 4.9 1.077.625.247.945.943.744 1.584l-.592 1.891a1.29 1.29 0 0 1-1.736.805 13.462 13.462 0 0 0-4.806-1.065c-2.643-.103-3.441.963-3.478 1.945-.047 1.209 1.507 2.1 4.902 3.291 4.852 1.662 6.813 3.78 6.671 7.443-.13 3.361-2.739 6.286-7.602 6.854l-.096 2.484a1.293 1.293 0 0 1-1.343 1.242l-1.303-.05a1.293 1.293 0 0 1-1.243-1.343Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M397.699 283.498c12.06 0 21.837-9.777 21.837-21.837 0-12.061-9.777-21.838-21.837-21.838-12.061 0-21.838 9.777-21.838 21.838 0 12.06 9.777 21.837 21.838 21.837Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M397.699 282.772c11.66 0 21.112-9.452 21.112-21.111 0-11.66-9.452-21.112-21.112-21.112-11.659 0-21.111 9.452-21.111 21.112 0 11.659 9.452 21.111 21.111 21.111Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M380.38 253.24a.537.537 0 0 1-.471-.785c3.503-6.756 10.403-10.902 18.007-10.819 1.212.013 2.426.135 3.609.364a.538.538 0 1 1-.205 1.056 19.217 19.217 0 0 0-3.416-.345c-7.195-.078-13.725 3.845-17.04 10.239a.538.538 0 0 1-.484.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M398.154 279.994c9.869 0 17.869-8 17.869-17.868 0-9.869-8-17.869-17.869-17.869-9.868 0-17.868 8-17.868 17.869 0 9.868 8 17.868 17.868 17.868Z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "m396.256 275.389.021-1.944c-2.026-.103-4.025-.603-5.442-1.241a1.126 1.126 0 0 1-.607-1.336l.514-1.805a1.133 1.133 0 0 1 1.546-.725c1.406.608 3.145 1.095 5.025 1.115 1.952.022 3.414-.624 3.429-1.981.013-1.224-1.103-1.964-3.808-2.721-3.859-1.101-6.62-2.818-6.583-6.225.034-3.077 2.309-5.401 6.219-5.987l.022-1.944a1.133 1.133 0 0 1 1.145-1.121l1.142.013a1.133 1.133 0 0 1 1.12 1.145l-.019 1.745c1.874.095 3.236.431 4.315.823.553.201.849.803.689 1.369l-.472 1.669a1.13 1.13 0 0 1-1.5.747 11.793 11.793 0 0 0-4.231-.816c-2.316-.025-2.988.927-2.997 1.787-.012 1.059 1.37 1.801 4.37 2.761 4.287 1.337 6.053 3.142 6.019 6.351-.033 2.945-2.244 5.567-6.486 6.183l-.024 2.175a1.133 1.133 0 0 1-1.145 1.121l-1.142-.013a1.133 1.133 0 0 1-1.12-1.145Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 203.469,
    x2: 206.393,
    y1: 156.357,
    y2: 154.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 149.359,
    x2: 221.646,
    y1: 216.322,
    y2: 193.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 222.774,
    x2: 224.73,
    y1: 86.652,
    y2: 85.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 186.568,
    x2: 234.937,
    y1: 126.776,
    y2: 111.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 207.966,
    x2: 127.164,
    y1: 391.753,
    y2: 479.644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 181.739,
    x2: 188.916,
    y1: 398.281,
    y2: 398.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 164.72,
    x2: 188.451,
    y1: 343.401,
    y2: 343.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 189.839,
    x2: 109.037,
    y1: 375.088,
    y2: 462.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 155.872,
    x2: 162.069,
    y1: 397.913,
    y2: 397.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 211.272,
    x2: 241.456,
    y1: 205.932,
    y2: 205.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 253.817,
    x2: 218.239,
    y1: 153.95,
    y2: 210.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 245.86,
    x2: 217.098,
    y1: 169.672,
    y2: 199.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 164.563,
    x2: 138.707,
    y1: 164.561,
    y2: 275.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 131.037,
    x2: 177.44,
    y1: 262.973,
    y2: 262.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 191.39,
    x2: 216.8,
    y1: 230.096,
    y2: 335.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 188.895,
    x2: 169.052,
    y1: 245.979,
    y2: 272.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 166.669,
    x2: 185.015,
    y1: 213.365,
    y2: 213.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 189.378,
    x2: 169.206,
    y1: 201.693,
    y2: 189.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 184.08,
    x2: 165.931,
    y1: 206.281,
    y2: 195.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4421B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C0E16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 382.801,
    x2: 410.772,
    y1: 185.64,
    y2: 151.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 426.406,
    x2: 344.633,
    y1: 125.965,
    y2: 258.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 428.318,
    x2: 369.029,
    y1: 134.685,
    y2: 195.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 379.274,
    x2: 414.207,
    y1: 247.336,
    y2: 209.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 434.193,
    x2: 329.559,
    y1: 182.246,
    y2: 327.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 435.689,
    x2: 362.632,
    y1: 192.423,
    y2: 257.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 367.44,
    x2: 397.1,
    y1: 296.018,
    y2: 262.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 413.921,
    x2: 325.885,
    y1: 237.726,
    y2: 367.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 415.476,
    x2: 353.132,
    y1: 246.594,
    y2: 305.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M67.373 24h413.254v388H67.373z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 450.974,
    height: 392.73,
    x: 51.89,
    y: 30.183,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 2,
    result: "effect1_dropShadow_2020_24997"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0392157 0 0 0 0 0.0352941 0 0 0 0 0.0431373 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2020_24997"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2020_24997",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSlider4);
export default __webpack_public_path__ + "static/media/login-slider-4.5d25572a3d8d8a98d2ecab9f09aedb10.svg";
export { ForwardRef as ReactComponent };